import React from 'react';
import PropTypes from 'prop-types';

const Lightning = ({ dimension = '', className = '' }) => (
  <svg
    width={dimension || '24px'}
    height={dimension || '24px'}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Transactions-Refund-pop-up-01"
        transform="translate(-763.000000, -522.000000)"
      >
        <g id="Group-27" transform="translate(532.000000, 213.000000)">
          <g id="Group-9" transform="translate(62.000000, 107.000000)">
            <g id="Group-8" transform="translate(169.000000, 202.000000)">
              <circle id="Oval" fill="#FFF6DD" cx="12" cy="12" r="12" />
              <g
                id="Selection-Box-Copy"
                transform="translate(6.461538, 4.615385)"
                fill="#DD8E04"
                fillRule="nonzero"
              >
                <g id="instant-refund">
                  <path
                    d="M9.84375715,6.08653846 L5.96424056,6.08653846 L9.31323959,0.64734825 C9.39612531,0.513371394 9.39563703,0.348970846 9.31189681,0.215444712 C9.22766828,0.08203125 9.0733714,0 8.90625715,0 L3.28125715,0 C3.07947494,0 2.90039778,0.119215731 2.83679915,0.29578575 L0.0242991541,8.11309344 C-0.0237965646,8.24492939 0.000495435396,8.39028695 0.0883860604,8.50307994 C0.176764967,8.61598558 0.318244467,8.68269231 0.468757154,8.68269231 L4.44544172,8.68269231 L1.91309309,14.1662785 C1.82239484,14.3611027 1.89844465,14.5880409 2.09253647,14.7016226 C2.2834544,14.8143029 2.53992415,14.784668 2.69397687,14.6239859 L10.1939769,6.80667819 C10.3166575,6.67946215 10.346931,6.49725811 10.2713695,6.34221003 C10.1958079,6.18671123 10.0283275,6.08653846 9.84375715,6.08653846 Z"
                    id="Path"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Lightning.propTypes = {
  dimension: PropTypes.string,
  className: PropTypes.string,
};

export default Lightning;
